/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import TimeOutModal from "./TimeOutModal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../redux/auth/actions";
import auth from "../config/auth";

const IdealTimeoutHooks = () => {
  const timeout = 3000000; // use for development 50 min
  // const timeout = 120000; use for real usage 2 min
  const [remaining, setRemaining] = useState(timeout);
  // const [elapsed, setElapsed] = useState(0);
  // const [lastActive, setLastActive] = useState(+new Date());
  const [isIdle, setIsIdle] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => setIsIdle(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userLogout = useSelector((state) => state?.auth?.userLogout);

  const { reset, getRemainingTime
    // , getLastActiveTime, getElapsedTime
   } =
    useIdleTimer({
      timeout,
      onActive: handleOnActive,
      onIdle: handleOnIdle,
    });

  const handleReset = () => reset();

  useEffect(() => {
    setRemaining(getRemainingTime());
    // setLastActive(getLastActiveTime());
    // setElapsed(getElapsedTime());

    setInterval(() => {
      setRemaining(getRemainingTime());
      // setLastActive(getLastActiveTime());
      // setElapsed(getElapsedTime());
    }, 1000);
  }, []);

  useEffect(() => {
    if (userLogout?.apiSuccess) {
      localStorage.clear();
      navigate("/");
      auth.logout();
    }
  }, [userLogout]);

  const handleClose = () => {
    setShowModal(false);
    handleReset();
    handleOnActive();
    setIsTimedOut(false);
  };

  const handleLogout = () => {
    setShowModal(false);
    const showNotification= true
    dispatch(acts.userLogout(showNotification));
  };

  useEffect(() => {
    if (isIdle) {
      if (isTimedOut) {
        const showNotification= true
        dispatch(acts.userLogout(showNotification));
      } else {
        handleReset();
        setIsTimedOut(true);
        setShowModal(true);
        handleOnActive();
      }
    }
  }, [isIdle]);

  return (
    <div>
      {showModal && (
        <TimeOutModal
          remaining={remaining}
          showModal={showModal}
          handleClose={handleClose}
          handleLogout={handleLogout}
        />
      )}
    </div>
  );
};

export default IdealTimeoutHooks;
